/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/metadata';
import '../../common/currency';
import '../../payments/network_numerics';
import '../common/common';
import '../../payments/refund';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "RefundRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": ".squareup.esperanto.common.Metadata",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "includePaymentRecord": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isOmnibusMastered": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "networkNumerics": {
                    "type": ".squareup.payments.networknumerics.NetworkNumerics",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "RefundResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.payments.refund.RefundError",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentRecord": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.RefundRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.RefundResponse) {
  $root.addJSON(jsonData);
}

/**
 * Represents the request payload for the linked refund request.
 *
 * This request and RefundResponse are being phased out in favor the various dual-message endpoints.
 *
 * SOURCE RefundRequest @ squareup/esperanto/api/legacy_refund.proto at 20:1
 */
export const RefundRequest = $root.lookupType('squareup.esperanto.api.RefundRequest');
fixType(RefundRequest, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(RefundRequest);
/**
 * SOURCE RefundResponse @ squareup/esperanto/api/legacy_refund.proto at 64:1
 */
export const RefundResponse = $root.lookupType('squareup.esperanto.api.RefundResponse');
fixType(RefundResponse);
Builder.createAndAttachToType(RefundResponse);